import { useState } from 'react'

import ButtonBlue from '../../../components/ui/button/_color/_blue'

import styles from './styles.module.scss'
import Img1Mobile from './images/img_1-mobile.png'
import Img2Mobile from './images/img_2-mobile.png'
import Img3Mobile from './images/img_3-mobile.png'

import TabIcon1 from './icons/tab_1-icon.svg'
import TabIcon2 from './icons/tab_2-icon.svg'
import TabIcon3 from './icons/tab_3-icon.svg'
import { useTranslation } from 'utils/use-translation'

export default function WhyInvite({ handleGoToRefferal }) {
  const { t } = useTranslation()
  
  const [activeTab, setActiveTab] = useState('Earn')

  const handleTabClick = (tabName) => {
    setActiveTab(tabName)
  }

  const tabContent = {
    Earn: {
      headerText: t('grow_passive_income_title'),
      paragraphText: t('earn_daily_interest'),
      buttonText: t('earn_now'),
      activeImg: Img1Mobile,
      headerBgColor: styles.headerBg1,
    },
    Exchange: {
      headerText: t('get_the_most_swaps'),
      paragraphText:
        t('exchange_market_pairs'),
      buttonText: t('exchange_now'),
      activeImg: Img2Mobile,
      headerBgColor: styles.headerBg2,
    },
    Borrow: {
      headerText: t('borrow_agains_your_crypto'),
      paragraphText: t('access_extra_funds_get_up'),
      buttonText: t('borrow_now'),
      activeImg: Img3Mobile,
      headerBgColor: styles.headerBg3,
    },
  }

  const { headerText, paragraphText, buttonText, activeImg, headerBgColor } = tabContent[activeTab]

  return (
    <>
      <div className={styles.wrapper}>
        <img className={styles.wrapper__left} src={activeImg} />
        <div className={styles.wrapper__right}>
          <div className={styles.tabs}>
            <div
              className={`${styles.tab} ${activeTab === 'Earn' ? styles.activeTab : ''}`}
              onClick={() => handleTabClick('Earn')}
            >
              <img className={styles.tabIcon} src={TabIcon1} />
              <span>{t('earn')}</span>
            </div>
            <div
              className={`${styles.tab} ${activeTab === 'Exchange' ? styles.activeTab : ''}`}
              onClick={() => handleTabClick('Exchange')}
            >
              <img className={styles.tabIcon} src={TabIcon2} />
              <span>{t('exchange')}</span>
            </div>
            <div
              className={`${styles.tab} ${activeTab === 'Borrow' ? styles.activeTab : ''}`}
              onClick={() => handleTabClick('Borrow')}
            >
              <img className={styles.tabIcon} src={TabIcon3} />
              <span>{t('borrow')}</span>
            </div>
          </div>
          <h2 className={`${styles.header} ${headerBgColor}`}>{headerText}</h2>
          <p className={styles.text}>{paragraphText}</p>
          <ButtonBlue bordered disableHoverColor className={styles.button} onClick={handleGoToRefferal}>
            {buttonText}
          </ButtonBlue>
        </div>
      </div>

      <div className={styles.mobile}>
        {Object.keys(tabContent).map((tabName) => (
          <div key={tabName} className={styles.mobile__item}>
            <img className={styles.img} src={tabContent[tabName].activeImg} />
            <h2 className={`${styles.header} ${tabContent[tabName].headerBgColor}`}>
              {tabContent[tabName].headerText}
            </h2>
            <p className={styles.text}>{tabContent[tabName].paragraphText}</p>
            <ButtonBlue bordered disableHoverColor className={styles.button} onClick={handleGoToRefferal}>
              {tabContent[tabName].buttonText}
            </ButtonBlue>
          </div>
        ))}
      </div>
    </>
  )
}
